import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import AudienceSelectionRadioBlocks from '../../../../../../../ReusableFormFields/Audiences/AudiencesFields/AudienceSelectionRadioBlocks'
import AudiencesInfoSection from '../../../../../../../ReusableFormFields/Audiences/AudiencesFields/AudiencesInfoSection'
import Spoiler from '../../../../../../../../components/Spoiler'
import TikTokAdvancedAudienceTargetingSection from './TikTokAdvancedAudienceTargetingSection'

import useIsAdvancedPartnership from '../../../../../../../../features/hooks/useIsAdvancedPartnership'
import { formatOptionsList } from '../../../../../../../../features/formatters'

import { selectedTikTokAdAccountSelector } from '../../../../../../../../modules/selectors/adAccounts'
import {
  tikTokCustomAudiencesIsLoadingSelector,
  tikTokCustomAudiencesSelector
} from '../../../../../../../../modules/selectors/tikTokConstants'
import {
  clearGetTikTokContentExclusionCategories,
  clearTikTokCustomAudiences,
  getTikTokContentExclusionCategories,
  getTikTokCustomAudiences
} from '../../../../../../../../modules/actions/tikTokConstants'

import { CUSTOM_AUDIENCES_EXCLUSION_CHECKED } from '../../../../../../../ReusableFormFields/Audiences/AudiencesFields/fields'
import { tiktokRightUploadAdDataSelector } from '../../../../../../../../modules/selectors/rights'

const TikTokUploadCreativeAudienceFields = ({ formik }) => {
  const dispatch = useDispatch()

  const { id: selectedAdAccountId } = useSelector(selectedTikTokAdAccountSelector)
  const tikTokCustomAudiences = useSelector(tikTokCustomAudiencesSelector)
  const tikTokCustomAudiencesIsLoading = useSelector(tikTokCustomAudiencesIsLoadingSelector)
  const { campaign } = useSelector(tiktokRightUploadAdDataSelector)
  const { objective: campaignObjective } = campaign

  const { t } = useTranslation()

  const { values } = formik

  const isAdvancedPartnership = useIsAdvancedPartnership()

  const formattedAudiences = useMemo(
    () =>
      formatOptionsList({
        list: tikTokCustomAudiences.filter(audience => audience['is_valid']),
        valueName: 'audience_id',
        labelName: 'name'
      }),
    [tikTokCustomAudiences]
  )

  useEffect(() => {
    dispatch(getTikTokCustomAudiences({ account: selectedAdAccountId, page_size: 100 }))

    return () => {
      dispatch(clearTikTokCustomAudiences())
    }
  }, [dispatch, selectedAdAccountId])

  useEffect(() => {
    dispatch(
      getTikTokContentExclusionCategories({
        account: selectedAdAccountId,
        objective_type: campaignObjective
      })
    )

    return () => {
      dispatch(clearGetTikTokContentExclusionCategories())
    }
  }, [dispatch, campaignObjective, selectedAdAccountId])

  return (
    <>
      {!isAdvancedPartnership && <AudiencesInfoSection targetAudiencesText="Target one or more audiences" />}
      <AudienceSelectionRadioBlocks
        formik={formik}
        audiencesIsLoading={tikTokCustomAudiencesIsLoading}
        formattedAudiences={formattedAudiences}
      />
      <Spoiler title={t('View more custom audience options')} initialOpen={values[CUSTOM_AUDIENCES_EXCLUSION_CHECKED]}>
        <TikTokAdvancedAudienceTargetingSection formik={formik} formattedAudiences={formattedAudiences} />
      </Spoiler>
    </>
  )
}

export default TikTokUploadCreativeAudienceFields
